import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
import FormData from 'form-data';
const FUNCTION_CODE = 'CREATE_FILE';

export async function createFile(
    userToken: string,
    payload: Record<string, unknown>,
) {
    try {

        const data = new FormData();
        data.append('file', payload.file);
        data.append('type', payload.type);
        data.append('name', payload.name);

        const response = await axios({
            method: 'post',
            url: `${URL}/files/`,
            data: data,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: "Une erreur de la création d'une pièce jointe",
            error: error
        });
    }
}